(() => {
  class CollectionInfiniteScroll {
    constructor(element) {
      this.element = element;
      this.loading = false;
      this.observer = new IntersectionObserver(
        (entries) => entries.forEach((entry) => entry.isIntersecting && this.loadNextPage()),
        { rootMargin: '500px 0px' }
      );
      this.observer.observe(element);
    }

    async loadNextPage() {
      const nextPageUrl = this.element.dataset.nextPageUrl;
      if (this.loading || !nextPageUrl) return;

      this.loading = true;
      this.element.classList.add('is-loading');
      this.element.querySelector('.collection-infinite-scroll__status').textContent = 'Loading more products';

      try {
        const response = await fetch(nextPageUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`Unable to load products (${response.status})`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incomingGrid = documentFragment.querySelector('#product-grid [data-product-column]');
        const incomingLoader = documentFragment.querySelector('[data-infinite-scroll]');
        const currentGrid = this.element.closest('#product-grid').querySelector('[data-product-column]');

        if (!incomingGrid || !currentGrid) throw new Error('The next product grid could not be found');
        currentGrid.append(...Array.from(incomingGrid.children));

        if (incomingLoader && incomingLoader.dataset.nextPageUrl) {
          this.element.dataset.nextPageUrl = incomingLoader.dataset.nextPageUrl;
          this.element.querySelector('.collection-infinite-scroll__status').textContent = '';
        } else {
          delete this.element.dataset.nextPageUrl;
          this.element.remove();
          this.observer.disconnect();
        }
      } catch (error) {
        console.error(error);
        this.element.querySelector('.collection-infinite-scroll__status').textContent = 'Unable to load more products. Please try again.';
      } finally {
        this.loading = false;
        this.element.classList.remove('is-loading');
      }
    }
  }

  const initialise = (root = document) => {
    root.querySelectorAll('[data-infinite-scroll]:not([data-infinite-scroll-ready])').forEach((element) => {
      element.dataset.infiniteScrollReady = 'true';
      new CollectionInfiniteScroll(element);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initialise();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initialise(node.parentElement);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
